"use client";

import { CreateTaskModal } from "@/app/[tenant]/(console)/tasks/modals/create-task-modal";

import { DocumentSummary } from "@/types/document";

interface RequestDocumentSignOffModalProps {
  document: DocumentSummary;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Wraps {@link CreateTaskModal} pre-filled to route a document to one provider
 * for review and sign-off. Mirrors CreateFaxTaskDialog:
 * an ordinary task (assignment + the single TASK_ASSIGNED alert) that targets a
 * document via `targetDocumentId`, so the assignee deep-links straight to it and
 * signing off the document auto-completes the task. The patient pre-fills from
 * the document's record.
 */
export default function RequestDocumentSignOffModal({
  document,
  open,
  onOpenChange,
}: RequestDocumentSignOffModalProps) {
  return (
    <CreateTaskModal
      open={open}
      onOpenChange={onOpenChange}
      defaultTitle={`Sign off document — ${document.title}`}
      defaultDescription={`Please review and sign off this document: ${document.title}`}
      defaultPatientId={document.patientId}
      // A sign-off request is pointless without a recipient: the backend only
      // fires the TASK_ASSIGNED alert when an assignee/team is set, so require one.
      requireAssignee
      targetDocumentId={document.id}
    />
  );
}
